import image from "../../img/profiles/avatar-16.jpg";
import { useSelector } from "react-redux";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useGetSingleAdminDataQuery } from "../../../redux-toolkit/services/AdminAuthApi/AdminAuthApi";



import { HiOutlineHome } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";
import { PiChatCenteredDotsLight } from "react-icons/pi";
import { LiaUsersSolid } from "react-icons/lia";
import ChatsMenu from "../ChatsMenu/ChatsMenu";
import { useEffect, useRef, useState } from "react";
import { AdminNotificationsAlert } from "../../Pages/AdminNotificationsAlert/AdminNotificationsAlert";



const SideBar = () => {

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const path = searchParams.get("path");

  const { AuthInfo } = useSelector((state) => state?.auth);

  const { data: AdminData, error, isLoading } = useGetSingleAdminDataQuery(AuthInfo?._id);


  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target)
      ) {
        setShowProfileMenu(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);


  if (isLoading) {
    return <></>;
  }

  return (
    <>

      <section className={`sidebar-section ${id ? "mobile-version" : ""}`} >
        <header className='sidebar-header-area'>
          <div className="sidebar-header">
            <a title='home' href="https://admin.wlfmobile.com">
              <HiOutlineHome />
            </a>

            <Link
              title="all users"
              to="?path=alluser"
              className={`${path !== "online" && path !== "chats" ? "active" : ""}`}
            >
              <LiaUsersSolid />
            </Link>

            <Link to="?path=online" className={`${path === "online" ? "active" : ""}`} title='online user'>
              <BsFillPersonLinesFill />
            </Link>
            <Link to="?path=chats"
              className={`${path === "chats" ? "active" : ""}`} title='all chats'>
              <PiChatCenteredDotsLight />
            </Link>

          </div>

        </header>

        <nav className='sidebar-nav-section sidebar-nav-user'>
          <ChatsMenu />
        </nav>

        <footer className='sidebar-footer-area'>
          <div className="sidebar-footer">
            {/* <div className="user-profile-icon">
              <img
                src={
                  AdminData?.data?.picture
                    ? `${process.env.REACT_APP_Authorized_API_URL}/${AdminData?.data?.picture}`
                    : image
                }
                onError={(e) => (e.target.src = image)}
                alt="Profile"
                className="user-profile-image"
              />
              <span className="user-online-dot"></span>
            </div> */}

            <div ref={profileMenuRef}>
              <div
                className="user-profile-icon"
                onClick={() => setShowProfileMenu((prev) => !prev)}

              >
                <img
                  src={
                    AdminData?.data?.picture
                      ? `${process.env.REACT_APP_Authorized_API_URL}/${AdminData?.data?.picture}`
                      : image
                  }
                  onError={(e) => (e.target.src = image)}
                  alt="Profile"
                  className="user-profile-image"
                />

                <span className="user-online-dot"></span>
              </div>

              {showProfileMenu && (
                <div className="profile-dropdown">
                  {/* <div
                    className="profile-dropdown-item"
                    onClick={() => {
                      setShowProfileMenu(false);
                      // Profile action
                    }}
                  >
                    <span className="menu-icon">👤</span>
                    <span>Profile</span>
                  </div> */}

                  <div
                    className="profile-dropdown-item"
                    onClick={() => {
                      setShowProfileMenu(false);
                      AdminNotificationsAlert(AdminData?.data);
                    }}
                  >
                    <span className="menu-icon">🔔</span>
                    <span>Notification</span>
                  </div>
                </div>
              )}
            </div>
          </div>

        </footer>

      </section>

    </>
  );
};

export default SideBar;
